import ListaPreciosVentaForm from "./ListaPreciosVentaForm.vue";
export default ListaPreciosVentaForm;
